/**
 * 富文本编辑器相关工具函数
 */

/**
 * 修复标题块结构，防止保存后重新加载时标题合并
 * @param {string} html - HTML 字符串
 * @returns {string} 修复后的 HTML 字符串
 */
export function fixHeadingBlocks(html) {
	if (!html) return html;
	let fixed = html;
	// 使用 &nbsp; 代替 <br>，避免被后端 getInfoWith 方法的 str_replace("><br><", "><") 删除
	// ql-block 是 Quill 编辑器的标准 class，编辑器会正常处理
	const separator = '<p class="ql-block">&nbsp;</p>';
	
	// 修复 h1 和 h2 紧靠在一起的情况，插入空段落作为分隔
	fixed = fixed.replace(/<\/h([12])>\s*<h([12])>/g, `</h$1>${separator}<h$2>`);
	// 修复末尾的 h1 或 h2，添加空段落
	fixed = fixed.replace(/<\/h([12])>\s*$/g, `</h$1>${separator}`);
	return fixed;
}
